import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";
import FASTable from "../../../../../components/Tables/FASTable";
import { FiMenu } from "react-icons/fi";
import {
  PurchaseAcList,
  PurchaseBookList,
  PurchaseBookSubBookParty,
  PurchaseSubBook,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Purchase/PurchaseSlice";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import { Loader } from "../../.././../../components/Loader/Loader";
import { format } from "date-fns";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export const BookWiseSubBookWise = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const {
    PurchaseBookListdata,
    PurchaseAcListtdata,
    PurchaseSubBookdata,
    PurchaseBookSubBookPartydata,
  } = useSelector((state) => state.PurchaseSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");

  const [filters, setFilters] = useState({
    month: [],
    purchaseBook: [],
    accounts: [],
    subBook: [],
  });
  const [search, setSearch] = useState({
    month: "",
    purchaseBook: "",
    accounts: "",
    subBook: "",
  });
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedPurchaseBook, setSelectedPurchaseBook] = useState("");
  const [selectedPurchaseBookId, setSelectedPurchaseBookId] = useState([]);

  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [selectedAccountNameId, setSelectedAccountNameId] = useState([]);

  const [selectedSubBook, setSelectedSubBook] = useState("");
  const [selectedSubBookId, setSelectedSubBookId] = useState([]);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };
  useEffect(() => {
    dispatch(PurchaseBookList({ Firm, Year: YearId }));
    dispatch(PurchaseAcList({ Firm, Year: YearId }));
    dispatch(PurchaseSubBook({ Firm, Year: YearId }));
    dispatch(PurchaseBookSubBookParty({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  const purchaseAccountList =
    PurchaseAcListtdata?.Dtl?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];
  const purchaseBookList =
    PurchaseBookListdata?.Dtl?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];

  const purchaseSubBookList =
    PurchaseSubBookdata?.Dtl?.map((item) => ({
      label: item?.SubBookName,
      value: item?.SubBookId,
    })) || [];

  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];
  const selectedMonthNames = monthOptions
    .filter((item) => filters.month.includes(item.id))
    .map((item) => item.month)
    .join(",");
  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const [activeTable, setActiveTable] = useState("BookWise Purchase");

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        BookIDs: filters.purchaseBook?.join(",") || "",
        selecteSubBookdIds: filters.subBook?.join(",") || "",
        selectSalepartyIds: filters.accounts?.join(",") || "",
        Month: selectedMonthNames,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await dispatch(PurchaseBookSubBookParty(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };
  const applyFilter1 = async () => {
    setIsFilterLoading(true);
    console.log("selectedAccountNameId", selectedAccountNameId);

    try {
      const payload = {
        Firm,
        Year: YearId,
        BookIDs: selectedPurchaseBookId.join(","),
        selecteSubBookdIds: selectedSubBookId.join(","),
        selectSalepartyIds: selectedAccountNameId.join(","),
        Month: selectedMonth,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await dispatch(PurchaseBookSubBookParty(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };
  const BookWisePurchaseRow = () => {
    return (
      PurchaseBookSubBookPartydata?.BookDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const BookWisePurchaseColums = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Book Name",
      key: "BookName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];
  const PrtyWiseAmtRow = () => {
    return (
      PurchaseBookSubBookPartydata?.PartyDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const PrtyWiseAmtColums = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];

  const subBookWiseRow = () => {
    return (
      PurchaseBookSubBookPartydata?.SubBookDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const subBookWiseColums = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "SubBook Name",
      key: "SubBookName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];

  const isLoading =
    !PurchaseBookSubBookPartydata ||
    !PurchaseAcListtdata ||
    !PurchaseBookListdata ||
    !PurchaseSubBookdata ||
    isFilterLoading;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <FASFilterBox
              title="Month"
              items={monthList}
              search={search.month || ""}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month || []}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            {/* Purchase Books */}
            <FASFilterBox
              title="Purchase Books"
              items={purchaseBookList}
              search={search.purchaseBook || ""}
              setSearch={(val) => handleSearch("purchaseBook", val)}
              selectedItems={filters.purchaseBook || []}
              toggleItem={(item) => toggleItem("purchaseBook", item)}
              selectAll={() => selectAll("purchaseBook", purchaseBookList)}
            />

            {/* Accounts */}
            <FASFilterBox
              title="Accounts"
              items={purchaseAccountList}
              search={search.accounts || ""}
              setSearch={(val) => handleSearch("accounts", val)}
              selectedItems={filters.accounts || []}
              toggleItem={(item) => toggleItem("accounts", item)}
              selectAll={() => selectAll("accounts", purchaseAccountList)}
            />

            {/* Sub Books */}
            <FASFilterBox
              title="Sub Books"
              items={purchaseSubBookList}
              search={search.subBook || ""}
              setSearch={(val) => handleSearch("subBook", val)}
              selectedItems={filters.subBook || []}
              toggleItem={(item) => toggleItem("subBook", item)}
              selectAll={() => selectAll("subBook", purchaseSubBookList)}
            />

            {/* Items */}

            {/* Apply Button */}
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Row className="">
        <div style={{ padding: "10px" }}>
          <div
            className="d-none d-lg-block"
            style={{
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
              }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3">
              {/* Row 1 */}
              <Col lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Months"
                  placeholder="Select Month Name"
                  data={monthList}
                  selectedValue={selectedMonth}
                  setSelectedValue={setSelectedMonth}
                  selectedId={selectedMonthId}
                  setSelectedId={setSelectedMonthId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Purchase Books"
                  placeholder="Select Purchase Books"
                  data={purchaseBookList}
                  selectedValue={selectedPurchaseBook}
                  setSelectedValue={setSelectedPurchaseBook}
                  selectedId={selectedPurchaseBookId}
                  setSelectedId={setSelectedPurchaseBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Row 2 */}
              <Col lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Accounts"
                  placeholder="Select Accounts"
                  data={purchaseAccountList}
                  selectedValue={selectedAccountName}
                  setSelectedValue={setSelectedAccountName}
                  selectedId={selectedAccountNameId}
                  setSelectedId={setSelectedAccountNameId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sub Books"
                  placeholder="Select Sub Books"
                  data={purchaseSubBookList}
                  selectedValue={selectedSubBook}
                  setSelectedValue={setSelectedSubBook}
                  selectedId={selectedSubBookId}
                  setSelectedId={setSelectedSubBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Row 3 */}
              <Col lg={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                  }}
                  className="common-hover-btn"
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
        </div>

        <Col xl={12} lg={12} md={12} sm={12}>
          <Row>
            <Col xl={12}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "14px",
                    margin: 0,
                  }}
                >
                  <h5
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    SUBBOOKWISE PURCHASE AMOUNT
                  </h5>
                </div>

                <FASTable data={subBookWiseRow()} columns={subBookWiseColums} />
              </div>
            </Col>
            <Col xs={12}>
              {/* ✅ BUTTONS */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginBottom: "12px",
                  marginTop: "20px",
                }}
              >
                {[
                  {
                    key: "BookWise Purchase",
                    label: "BOOKWISE PURCHASE",
                  },
                  { key: "PartyWise Purchase", label: "PARTYWISE PURCHASE" },
                ].map((btn) => (
                  <button
                    key={btn.key}
                    onClick={() => setActiveTable(btn.key)}
                    style={{
                      flex: 1,
                      height: "52px",
                      borderRadius: "14px",
                      cursor: "pointer",
                      fontWeight: "600",
                      border: `2px solid ${
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                      }`,
                      background:
                        activeTable === btn.key
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                      color:
                        activeTable === btn.key
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1
                          : isdark === "light"
                            ? iscolour?.Colour12
                            : iscolourDark?.Colour11,
                    }}
                  >
                    {btn.label}
                  </button>
                ))}
              </div>

              {/* ✅ HEADING */}
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  {activeTable === "BookWise Purchase"
                    ? "BOOKWISE PURCHASE AMOUNT"
                    : "PARTY PURCHASE AMOUNT"}
                </h5>
              </div>

              {/* ✅ TABLE SWITCH */}
              <div
                style={{
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <FASTable
                  data={
                    activeTable === "BookWise Purchase"
                      ? BookWisePurchaseRow()
                      : PrtyWiseAmtRow()
                  }
                  columns={
                    activeTable === "BookWise Purchase"
                      ? BookWisePurchaseColums
                      : PrtyWiseAmtColums
                  }
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
